import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/sharp-solid-svg-icons';
import { SCFormLabel } from '..';
import './index.css';

interface SCListBoxProps {
  Title: string;
  Values: string[];
  Visible?: boolean;
  OnDelete: (value: string) => void;
}

export function SCListBox(props: SCListBoxProps) {
  if (props.Visible != undefined && !props.Visible) return null;
  return (
    <div>
      <SCFormLabel label={props.Title} />
      <div className="sc-list-box-container">
        {props.Values.map((value) => (
          <div className="sc-list-box-item-container" key={value}>
            <span>{value}</span>
            <div className="sc-list-box-delete-icon" onClick={() => props.OnDelete(value)}>
              <FontAwesomeIcon icon={faX} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
